import React from 'react';
import PropTypes from 'prop-types';

const GlassCard = ({
  children,
  variant = 'default',
  color = 'neutral',
  glow = false,
  glowIntensity = 'subtle',
  hoverEffect = 'none',
  decorativeElements = false,
  className = '',
  ...otherProps
}) => {
  // Filter out non-DOM props
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { decorativeelements, ...domProps } = otherProps;

  // Base classes
  const baseClasses = [
    'backdrop-blur-md',
    'rounded-xl',
    'transition-all duration-300',
    'relative',
    className
  ];

  if (variant === 'bordered') {
    baseClasses.push('border border-slate-700/30');
  }

  // Color styles
  const colorClasses = {
    neutral: 'bg-slate-900/30',
    primary: 'bg-violet-900/30',
    mixed: 'bg-gradient-to-br from-slate-900/30 to-slate-800/30',
  };
  baseClasses.push(colorClasses[color] || colorClasses.neutral);

  // Glow effect
  if (glow) {
    const glowClasses = {
      subtle: 'shadow-lg shadow-violet-500/10',
      medium: 'shadow-xl shadow-violet-500/20',
      strong: 'shadow-2xl shadow-violet-500/30'
    };
    baseClasses.push(glowClasses[glowIntensity] || glowClasses.subtle);
  }

  // Hover effect
  if (hoverEffect === 'lift') {
    baseClasses.push('hover:-translate-y-1 hover:shadow-xl');
  } else if (hoverEffect === 'glow') {
    baseClasses.push('hover:shadow-xl hover:shadow-violet-500/20');
  }

  return (
    <div className={baseClasses.filter(Boolean).join(' ')} {...domProps}>
      {decorativeElements && (
        <>
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-violet-400/30 rounded-full"></div>
          <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-blue-400/30 rounded-full"></div>
        </>
      )}
      {children}
    </div>
  );
};

GlassCard.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'bordered']),
  color: PropTypes.oneOf(['neutral', 'primary', 'mixed']),
  glow: PropTypes.bool,
  glowIntensity: PropTypes.oneOf(['subtle', 'medium', 'strong']),
  hoverEffect: PropTypes.oneOf(['none', 'lift', 'glow']),
  decorativeElements: PropTypes.bool,
  className: PropTypes.string
};

export default GlassCard;
